import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { switchMap, mergeMap, tap, catchError } from 'rxjs/operators';
import { LoginService } from "../login/login.service";
import { SharedService } from "../helper/shared/shared.service";
import { UserInfoService } from "../user-info/user-info.service";
import { ToastrService } from 'ngx-toastr';
import { isNullOrEmpty, isNullOrUndefined } from '../helper/validation';

export interface Recipient { 
    Name: string;
    Email: string; 
}

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  loginToken: string;
  projectdetails: any = {};
  listData;
  activePage = 0;
  pages = ['customerInfo', 'siteInfo', 'contamination', 'solutions', 'results', 'reportGen'];
  astmpages = ['customerInfo', 'siteInfo', 'contamination', 'results', 'reportGen'];

  projectDetails_successResult: string = '';
  errPage = '';

  valid: any = {
    'customerInfo': 'Invalid',
    'siteInfo': 'Invalid',
    'contamination': 'Invalid',
    'solutions': 'Invalid',
    'results': 'Invalid',
    'reportGen': 'Invalid',
  };

  constructor(private httpService: HttpClient,
    private loginService: LoginService,
    private sharedService: SharedService,
    private userInfoService: UserInfoService,
    private toastr: ToastrService) {
    this.loginToken = this.loginService.cookieSvc.get("CFSSLoginCode");
  }

  getNewProjectDetails() {
    this.projectdetails = {};
    let project = {
      projectInfo: this.getProjectInfoEmptyValueStructure(),
      customerInfo: this.getCustomerInfoEmptyValueStructure(),
      siteInfo: this.getSiteInfoEmptyValueStructure(),
      contamination: this.getContaminationEmptyValueStructure(),
      solutions: [this.getSolutionsForComparisonEmptyValueStructure()],
      //solutions:[],
      results: this.getResultsEmptyValueStructure(),
      reportOptions: this.getReportOptionsEmptyValueStructure(),
    }
    //this.projectdetails=project;
    return project;
  }

  getProjectInfoEmptyValueStructure() {
    let projectInfo = {
      id: 0,
      folderId: 0,
      calculationType: '', // CLD / ASTM
      projectDate: new Date(),
      projectName: '',
      projectDesc: '',
      unitId: this.userInfoService.userData.UserUnitId,
      unitName: this.userInfoService.userData.UserUnitName,
      concUnitId: 1,
      concUnit: "ppb"
      //airflowUnit: "" contamination has airflowUnit
    }
    return projectInfo;
  }

  getCustomerInfoEmptyValueStructure() {
    let customerInfo = {
      customername: "",
      contactperson: "",
      title: "",
      contactnum: "",
      email: "",
      street: "",
      city: "",
      state: "",
      country: ""
    }
    return customerInfo;
  }

  getSiteInfoEmptyValueStructure() {
    let siteInfo = {
      siteName: "",
      ahu: "",
      location: "",
      building: "",
      room: "",
      siteDesc: ""
    }
    return siteInfo;
  }

  getContaminationEmptyValueStructure() {
    let contamination = {
      airflowUnit: this.userInfoService.userData.AirFlowUnit,
      airflow: parseFloat(this.listData.AirFlow.DefaultValue),
      temperature: parseFloat(this.listData.Temperature.DefaultValue),
      relativeHumidity: 50,
      //runningTime: 0,
      runningTime: "",
      //gasDetails:this.getGasDetailsEmptyvalueStructure(),
      //gasDetails:[this.getGasDetailsEmptyvalueStructure()],
      totalAirVolume: 0,  //Modified by JW(2022-09-01): need it for result page
      gasDetails: [],
      applicationType: ""
    }
    return contamination;
  }

  getSolutionsForComparisonEmptyValueStructure() {
    let solutions = {
      solutionID: 1, //Max 3 Solutions
      solutionName: 'Solution 1',
      solutionDetails: [],
      editMode: false
      //solutionDetails:this.getsolutionDetailsEmptyvalueStructure()
    }
    return solutions;
  }

  getsolutionDetailsEmptyvalueStructure() {
    let solutionsDetails = {
      combinationID: 0,
      combinationGas: [],
      //combinationGas:[this.getCombinationGasEmptyvalueStructure()],
      molecularGroup: '',
      molecularGroupID: 0,
      molecularType: '',
      molecularTypeID: 0,
      molecularTypePic: '',
      molecularTypeMolecularID: 0,
      molecularID: 0,
      molecularPic: '',
      filterName: '',
      filterDBName: '',
      //Modified by JW(2022-08-29): for ASTM use-start
      astmWeight: 0,
      astmvolume: 0,
      //Modified by JW(2022-08-29): for ASTM use-end
      inputSize: 0,     
      customMediaSize: this.getCustomMediaSizeEmptyvalueStructure(),
      noOfFilter: 1,
      totalStage: 1,
      displayTypeForMoreInfo: 'More Information',
      moreInformation: this.getMoreInfoForSolutionEmptyvalueStructure(),
    }
    return solutionsDetails;
  }

  getCustomMediaSizeEmptyvalueStructure() {
    let customMediaSize = {
      shapeType: 1, //1: rectangle, 2: cylinder - Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
      height: 0,
      length: 0,
      diameter:0, //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
      depth: 0
    }
    return customMediaSize;
  }

  getResultsEmptyValueStructure() {
    let solutionsResults = {
      resultReady: false,
      solutionsResults: [this.getMCCLDSolutionsResultsEmptyvalueStructure()],
      comparisonReport: this.getChartPathEmptyValueStructure(),
      extractCalcInExcel: this.getChartPathEmptyValueStructure()
    }
    return solutionsResults;
  }

  getMCCLDSolutionsResultsEmptyvalueStructure() {
    let mccldSolutionsResults = {
      solutionID: 1, //Max 3 Solutions
      solutionName: '',
      resultReady: false,
      results: [this.getResultsEmptyvalueStructure()],
      report: [this.getReportEmptyvalueStructure()],
      astmResults: this.getASTMResultsEmptyvalueStructure(),
    }
    return mccldSolutionsResults;
  }

  getResultsEmptyvalueStructure() {
    let results = {
      combinationID: 0,
      combinationGas: [this.getCombinationGasEmptyvalueStructure()],
      msg: [this.getFailMessageEmptyvalueStructure()],
      molecularGroup: '',
      molecularGroupID: 0,
      molecularType: '',
      molecularTypeID: 0,
      molecularID: 0,
      filterName: '',
      filterDBName: '',
      effMediaWeight: 0,
      totalWeight: 0,
      frontVelocity: 0,
      pressureDrop: 0,
      contactTime: 0,
      AtmPressure: 0,
      Calc_we: 0,
      Calc_Wo: 0,
      Calc_B: 0,
      Calc_Kv: 0,
      vFv: 0,
      vFa: 0,
      vFFa: 0,
      vWcf: 0,
      Efficiency: [],
      LifeTimeHours: [],
      ExcelFileName: '',
      FilterTypeFilterID: 0, //what is this for? can delete?
      EffHoursChart: this.getChartPathEmptyvalueStructure()
    }
    return results;
  }

  getFailMessageEmptyvalueStructure() {
    let failMsg = {
      message: ''
    }
    return failMsg;
  }

  getChartPathEmptyvalueStructure() {
    let chartPath = {
      found: false,
      path: '',
      message: ''
    }
    return chartPath;
  }

  getReportEmptyvalueStructure() {
    let reports = {
      molecularGroupID: 0,
      molecularTypeID: 0,
      molecularID: 0,
      chemicalID: 0,
      toPDF: this.getChartPathEmptyvalueStructure(),
      toExcel: this.getChartPathEmptyvalueStructure()
    }
    return reports;
  }

  getASTMResultsEmptyvalueStructure() {
    let astmResults = {
      combinationID: 0,
      combinationGas: [this.getCombinationGasEmptyvalueStructure()],
      msg: this.getFailMessageEmptyvalueStructure(),
      //Modified by JW(2022-08-29): add contamination usage-start
      contaminantPerYear: 0,
      //Modified by JW(2022-08-29): add contamination usage-end
      mediaConsumption1Month: 0,
      mediaConsumption3Month: 0,
      mediaConsumption6Month: 0,
      mediaConsumption12Month: 0,
      mediaConsumption24Month: 0,
      //Modified by JW(2022-09-07): add mediaId and filter photo path to astm result class-start
      mediaID: 0,
      mediaPicture: ""
      //Modified by JW(2022-09-07): add mediaId and filter photo path to astm result class-end
    }

    return astmResults;
  }

  getReportOptionsEmptyValueStructure() {
    let reportOptions = {
      reportsToGenerate: '',
      graphSeriesToGenerate: '',
      reportSettings: this.getReportSettingsEmptyvalueStructure(),
      ReportInfoBySol: []
      //ReportInfoBySol:[this.getReportInfoBySolEmptyValueStructure()],
    }

    return reportOptions;
  }

  getReportSettingsEmptyvalueStructure() {
    let reportSettings = {
      weightOfAdsorbant: false,
      contaminationInformation: false,
      filterSize: false,
      numberOfFilter: false,
      emailToMe: false,
      totalIndicativeWeight: false,
      frontVelocity: false,
      pressureDrop: false,
      contactTime: false
    }

    return reportSettings;
  }

  getReportInfoBySolEmptyValueStructure() {
    let reportInfoBySol = {
      solutionID: 1, //Max 3 Solutions
      solutionName: 'Solution 1',
      solDetails: []
      //solDetails:[this.getReportInfoDetailsEmptyvalueStructure()]
    }

    return reportInfoBySol;
  }

  getReportInfoDetailsEmptyvalueStructure() {
    let reportInfoDetails = {
      //combinationGas:[this.getCombinationGasEmptyvalueStructure()],
      combinationID: 0,
      molecularGroup: '',
      molecularGroupID: 0,
      molecularType: '',
      molecularTypeID: 0,
      molecularID: 0,
      filterName: '',
      filterDBName: '',
      //mediaDBName: '',
      newFilterGroup: '',
      newFilterType: '',
      newMedia: ''
    }

    return reportInfoDetails;
  }

  getGasDetailsEmptyvalueStructure() {
    let gasDetails = {
      index: 0,
      chemicalID: 0,
      contaminationType: '',
      displayTypeForMoreInfo: 'More Information',
      otherGas: false,
      concentrationValue: 0,
      gasWarningDetail: '',
      gasWarningColor: 0,
      altConcValue: 0,
      altConcUnit: '',
      moreInformation: this.getmoreInfoForGasEmptyvalueStructure(),
      otherGasDetails: this.getOtherGasDetailsEmptyvalueStructure()
    }

    return gasDetails;
  }

  getOtherGasDetailsEmptyvalueStructure() {
    let otherGasDetails = {
      otherContaminantID: 0,
      otherContaminantName: '',
      chemicalFormula: '',
      density: 0,
      molecularWeight: 0,
      boilingPoint: 0,
      refractiveIndex: 0,
      vapourPressureValue: 0
    }

    return otherGasDetails;
  }

  getmoreInfoForGasEmptyvalueStructure() {
    let moreInfoForGas = {
      chemicalFormula: '',
      vapourPressureValue: 0,
      molecularWeight: 0,
      boilingPoint: 0,
      casNo: ''
    }

    return moreInfoForGas;
  }

  getCombinationGasEmptyvalueStructure() {
    let combinationGas = {
      index: 0, //Modified by PP(2023-06-07) : Allow same gas diff conc value
      chemicalID: 0,
      contaminationType: '',
      concentrationValue: 0 //Modified by PP(2023-06-07) : Allow same gas diff conc value
    }

    return combinationGas;
  }

  getMoreInfoForSolutionEmptyvalueStructure() {
    let moreInfoForSol = {
      effectiveMediaWeight: 0,
      frontVelocity: 0,
      totalWeight: 0,
      contactTime: 0
    }

    return moreInfoForSol;
  }

  getChartPathEmptyValueStructure() {
    let chartPath = {
      found: false,
      path: "",
      message: ""
    }

    return chartPath;
  }

  checkValidation(activeFlag: number) {
    let res = false;
    let currpages = this.pages;
    //Modified by JW(2022-09-07): add astmpages[] for page validation-start
    if (this.projectdetails.projectInfo.calculationType === "ASTM") {
      currpages = this.astmpages;
    }

    switch (currpages[activeFlag - 1]) {
      //Modified by JW(2022-09-07): add astmpages[] for page validation-end
      case "customerInfo":
        if (this.valid['customerInfo'] === 'Skipped') {
          res = true;
        } else {
          res = this.validateCustomerInfo(this.projectdetails.customerInfo);
        }
        break;
      case "siteInfo":
        if (this.valid['siteInfo'] === 'Skipped') {
          res = true;
        } else {
          res = this.validateSiteInfo(this.projectdetails.siteInfo);
        }
        break;
      //Modified by JW(2022-08-24): validation check on ASTM entries-start
      // case "contamination":
      //     res = this.validateContamination(this.projectdetails.contamination);
      //     break;
      case "contamination":
        if (this.projectdetails.projectInfo.calculationType === "CLD") {
          res = this.validateContamination(this.projectdetails.contamination);
        } else if (this.projectdetails.projectInfo.calculationType === "ASTM") {
          res = this.validateASTM(this.projectdetails.contamination, this.projectdetails.solutions);
        }
        break;
      //Modified by JW(2022-08-24): validation check on ASTM entries-end
      case "solutions":
        res = this.validateSolutions(this.projectdetails.solutions);
        break;
      case "results":
        return true;
        break;
      case "reportGen":
        return true;
        break;

    }
    return res;
  }

  validateCustomerInfo(customerdata: any) {
    if (isNullOrEmpty(customerdata.customername)) {
      this.toastr.warning('Please key-in Customer Name.', '');
      return false;
    } else {
      return true;
    }
  }

  validateSiteInfo(sitedata: any) {
    if (isNullOrEmpty(sitedata.siteName)) {
      this.toastr.warning('Please key-in Site Name.', '');
      return false;
    } else {
      return true;
    }
  }

  validateContaminationORI(contamination: any) {
    if (contamination.gasDetails[0].chemicalID == 0) {
      if (contamination.gasDetails[0].contaminationType == '') {
        this.toastr.warning('Please select contaminant', '');
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  validateContamination(contamination: any) {
    if (contamination.gasDetails[0].chemicalID == 0) {
      if (contamination.gasDetails[0].contaminationType == '') {
        this.toastr.warning('Please select contaminant', '');
        return false;
      } else {
        return true;
      }
    } else {
      for (let i = 0; i < contamination.gasDetails.length; i++) {
        var dup = this.checkDuplicates(contamination.gasDetails[i], i, contamination.gasDetails);
        if (dup) {
          this.toastr.warning('Duplicate contaminant : ' + contamination.gasDetails[i].contaminationType + ' with Concentration Value of ' + contamination.gasDetails[i].concentrationValue, '');
          return false;
        } else {
          return true;
        }
      }
      return true;
    }
  }

  checkDuplicates(pCurrObj: any, pIndex, pAllObj: any) {
    for (let j = 0; j < pAllObj.length; j++) {
      if (pAllObj[j].index != pIndex) {
        if (pAllObj[j].chemicalID === pCurrObj.chemicalID) {
          if (pAllObj[j].concentrationValue === pCurrObj.concentrationValue) {
            return true;
          }
        }
      }

    }
    return false;
  }

  validateSolutions(solutions: any) {
    //Modified by PP(2022-11-10) : To stop solutions page into checking validation automatically. Must go through NgOnDestroy - START   
    if (this.sharedService.CalculationInProgress) {
      this.toastr.warning('Calculating for More Information values. Please wait...', '');
      return false;
    }
    //Modified by PP(2022-11-10) : To stop solutions page into checking validation automatically. Must go through NgOnDestroy - END

    if (solutions.length === 0) {
      this.toastr.warning('Solutions have not been created. Please select media', '');
      return false;
    } else {
      //Modified by PP(2023-05-12) : Bugs. If Add new solution but media not selected but still proceed to Results page - START
      // if (solutions.length === 1) {
      //   for (var i=0; i<solutions.length; i++) {
      //     if (solutions[i].solutionDetails[0].molecularID == 0) {
      //       this.toastr.warning('Solutions have not been created. Please select media', '');
      //       return false;
      //     } else {
      //       return true;
      //     }
      //   }
      //   return true;
      // } else {
      //   return true;
      // }

      for (var i = 0; i < solutions.length; i++) {
        for (var j = 0; j < solutions[i].solutionDetails.length; j++) {
          if (solutions[i].solutionDetails[j].molecularID == 0) {
            this.toastr.warning(solutions[i].solutionName + ' has been created but media NOT selected. Please select media', '');
            return false;
          }
        }
      }

      return true;
      //Modified by PP(2023-05-12) : Bugs. If Add new solution but media not selected but still proceed to Results page - END
    }
  }

  //Modified by JW(2022-08-24): validation check on ASTM entries-start
  validateASTM(contamination: any, solutions: any) {
    let result = true;
    let numformat = "sv-SE";
    if (this.userInfoService.userData.NumberFormatId === 2) {
      numformat = "en-US";
    }

    let runninghours = this.sharedService.convertLocaletoNumber(contamination.runningTime, numformat);
    if (runninghours <= 0) {
      this.toastr.warning('Please check Running Time.', '');
      return result = false;
    }

    let airflowvalue = this.sharedService.convertLocaletoNumber(contamination.airflow, numformat);
    if (airflowvalue <= 0) {
      this.toastr.warning('Please check Air Flow value.', '');
      return result = false;
    }

    let temperaturevalue = this.sharedService.convertLocaletoNumber(contamination.temperature, numformat);
    if (temperaturevalue <= 0) {
      this.toastr.warning('Please check Temperatire value.', '');
      return result = false;
    }

    if (solutions.length > 0) {
      for (let i = 0; i < solutions.length; i++) {
        let sol = solutions[i];
        let detail = sol.solutionDetails[0];
        if (sol.solutionName === "") {
          this.toastr.warning('Please key-in Name for Solution ' + (i + 1), '');
          return result = false;
        }
        if (detail.combinationGas[0].chemicalID === 0 && detail.combinationGas[0].contaminationType === "") {
          this.toastr.warning('Please select contamination gas for Solution ' + (i + 1), '');
          return result = false;
        }
        if (detail.molecularID === 0) {
          this.toastr.warning('Please select Media for Solution ' + (i + 1), '');
          return result = false;
        }
        let concvalue = this.sharedService.convertLocaletoNumber(contamination.gasDetails[i].concentrationValue, numformat);
        if (concvalue <= 0 || isNaN(concvalue)) {
          this.toastr.warning('Please check Concentration value for Solution ' + (i + 1), '');
          return result = false;
        }
      }
    }
    return result;
  }
  //Modified by JW(2022-08-24): validation check on ASTM entries-end

  CheckProjExist(projName, projID, pfolderID) {
    let body = {
      'ApplicationID': this.sharedService.ApplicationID,
      'UserID': this.userInfoService.userData.UserId,
      'UserName': this.userInfoService.userData.UserName,
      'Code': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'FolderID': pfolderID,
      'ProjectName': projName,
      'ProjectID': projID
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDProjectNameExist', body).pipe(catchError(this.sharedService.handleError));
  }

  UploadServerData2TempStringStorage(dataToUpload: any): Observable<any> {
    let body = {
      ID: dataToUpload.ID,
      TempString: dataToUpload.TempString,
      Seq: dataToUpload.Seq
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sService + 'TempStringStorage', body).pipe(catchError(this.sharedService.handleError));
  }

  emailURL(sendTo: Recipient[], URLLink: string, sharedProjectName: string): Observable<any> {
    const recipients = (sendTo ?? []).filter(r => r?.Email?.trim());
    let toEmailParams = {
      ApplicationID: this.sharedService.ApplicationID,
      UserID: this.userInfoService.userData.UserId,
      Username: this.userInfoService.userData.UserName.toString(),
      UserFullName: this.userInfoService.userData.FullName,
      UserEmail: this.userInfoService.userData.Email,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      RegionID: this.userInfoService.userData.RegionId.toString(),
      LanguageID: this.userInfoService.userData.LanguageId.toString(),
      //TempStringStorageID: this.sharedService.TempStringStorageID,
      //TotalSeq: this.sharedService.TempStringStorageTotalSeq,
      URLLink: URLLink,
      SharedProjectName: sharedProjectName,
      Recipients: recipients
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDEmailURLLink', toEmailParams).pipe(catchError(this.sharedService.handleError));
  }

  exportToXML(filesSelected, pExportType): Observable<any> {
    let toXMLParams = {
      ApplicationID: this.sharedService.ApplicationID,
      UserID: this.userInfoService.userData.UserId,
      Username: this.userInfoService.userData.UserName,
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      RegionID: this.userInfoService.userData.RegionId,
      TempStringStorageID: this.sharedService.TempStringStorageID,
      TotalSeq: this.sharedService.TempStringStorageTotalSeq,
      LanguageID: this.userInfoService.userData.LanguageId,
      ProjectID: filesSelected,
      ExportType: pExportType
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'ExportMCCLDDataToXMLFile', toXMLParams).pipe(catchError(this.sharedService.handleError));
  }

  importFromXML(filesDropped: any, URL: string) {
    let fromXMLParams = {
      ApplicationID: this.sharedService.ApplicationID,
      UserID: this.userInfoService.userData.UserId,
      Username: this.userInfoService.userData.UserName.toString(),
      Code: this.loginService.cookieSvc.get("CFSSLoginCode"),
      FileName: filesDropped[0],
      URLLink: URL,
      LanguageID: this.userInfoService.userData.LanguageId.toString(),
      RegionID: this.userInfoService.userData.RegionId.toString()
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'ImportMCCLDDataFromXMLFile', fromXMLParams).pipe(catchError(this.sharedService.handleError));
  }

  callLoadProjectApi(projectId, generateResult): Observable<any> {
    let body = {
      'UserID': this.userInfoService.userData.UserId,
      'Username': this.userInfoService.userData.UserName,
      'ApplicationID': this.sharedService.ApplicationID,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'ProjectID': projectId,
      'ServerDB': true,
      'LanguageID': this.userInfoService.userData.LanguageId,
      'RegionID': this.userInfoService.userData.RegionId,
      'GenerateResults': generateResult
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDLoadSelectedRecord', body).pipe(catchError(this.sharedService.handleError));
  }

  getProjectStructure(backendStructure): any {
    let projectdetails = {
      projectInfo: {},
      customerInfo: {},
      siteInfo: {},
      contamination: {},
      solutions: {},
      results: undefined
    };

    let cond = false;

    if (backendStructure !== undefined) {
      if (backendStructure.constructor === Object) {
        //if (backendStructure.Process.Fail === false) {
        cond = true;
        //}
      }
    }

    let concentrationId: number;
    switch (backendStructure.Params.ProjectInfo.ConcUnit) {
      case this.sharedService.ConcencDesc_ppb:
        concentrationId = 1;
        break;
      case this.sharedService.ConcencDesc_mgm3:
        concentrationId = 2;
        break;
    }

    if (cond) {
      try {
        //Project Info
        let projectInfo = {
          id: backendStructure.Params.ProjectInfo.ProjectID,
          projectName: backendStructure.Params.ProjectInfo.ProjectName,
          projectDesc: backendStructure.Params.ProjectInfo.ProjectDesc,
          unitId: backendStructure.Params.ProjectInfo.UnitId,
          concUnitId: concentrationId,
          concUnit: backendStructure.Params.ProjectInfo.ConcUnit,
          projectDate: backendStructure.Params.ProjectInfo.ReportDate,
          folderId: backendStructure.Params.ProjectInfo.FolderID,
          calculationType: backendStructure.Params.CalcType
        };
        projectdetails.projectInfo = projectInfo;
        //this.projectdetails.projectInfo = projectInfo;

        // Customer Info
        let customerInfo = {
          customername: backendStructure.Params.CustomerInfo.CustomerCompanyName,
          contactperson: backendStructure.Params.CustomerInfo.Contact,
          title: backendStructure.Params.CustomerInfo.ContactTitle,
          contactnum: backendStructure.Params.CustomerInfo.ContactPhoneNo,
          email: backendStructure.Params.CustomerInfo.ContactEmail,
          street: backendStructure.Params.CustomerInfo.ContactStreet,
          city: backendStructure.Params.CustomerInfo.ContactCity,
          state: backendStructure.Params.CustomerInfo.ContactState,
          country: backendStructure.Params.CustomerInfo.ContactCountry
        };
        projectdetails.customerInfo = customerInfo;
        //this.projectdetails.customerInfo = customerInfo;

        //Site Info
        let siteInfo = {
          siteName: backendStructure.Params.SiteInfo.SiteName,
          location: backendStructure.Params.SiteInfo.Location,
          building: backendStructure.Params.SiteInfo.Building,
          room: backendStructure.Params.SiteInfo.Room,
          ahu: backendStructure.Params.SiteInfo.Ahu,
          siteDesc: backendStructure.Params.SiteInfo.Description
        };
        projectdetails.siteInfo = siteInfo;
        //this.projectdetails.siteInfo = siteInfo;

        //Contamination
        let contamination = {
          airflowUnit: backendStructure.Params.ProjectInfo.AirFlowUnit,
          //Modified by PP(2023-02-15) : Load Project go Results it re-generates airflow : backendStructure.Params.Contamination.AirFlow,
          airflow: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.AirFlow).toFixed(3), this.userInfoService.userData.currentLocale), //Modified by PP(2023-02-15) : Load Project go Results it re-generates
          //temperature : backendStructure.Params.Contamination.Temperature.toFixed(1),
          temperature: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.Temperature).toFixed(2), this.userInfoService.userData.currentLocale),
          relativeHumidity: backendStructure.Params.Contamination.RelativeHumidity,
          //runningTime : backendStructure.Params.Contamination.RunningTime,
          runningTime: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.RunningTime), this.userInfoService.userData.currentLocale),
          applicationType: 'ALL',
          gasDetails: []
        };

        for (var i = 0; i < backendStructure.Params.Contamination.GasDetails.length; i++) {
          //Modified by PP(2023-02-17) : Bugs. To check the actual concentration unit - START
          var ActualConcValue: any;
          var ActualAltConcValue: any;
          var ActualAltConcUnit: any;
          if (projectInfo.concUnit === backendStructure.Params.Contamination.GasDetails[i].AltConcUnit) {
            switch (projectInfo.concUnit) {
              case "ppb":
                ActualAltConcUnit = "mg/m³";
                break;

              case "mg/m³":
                ActualAltConcUnit = "ppb";
                break;
            }
            ActualConcValue = backendStructure.Params.Contamination.GasDetails[i].AltConcValue;
            ActualAltConcValue = backendStructure.Params.Contamination.GasDetails[i].ConcentrationValue;
          } else {
            ActualConcValue = backendStructure.Params.Contamination.GasDetails[i].ConcentrationValue;
            ActualAltConcValue = backendStructure.Params.Contamination.GasDetails[i].AltConcValue;
            ActualAltConcUnit = backendStructure.Params.Contamination.GasDetails[i].AltConcUnit;
          }
          //Modified by PP(2023-02-17) : Bugs. To check the actual concentration unit - END

          let gasDetails = {
            index: i,
            chemicalID: backendStructure.Params.Contamination.GasDetails[i].ChemicalID,
            contaminationType: backendStructure.Params.Contamination.GasDetails[i].ContaminationType,
            displayTypeForMoreInfo: "More Information",
            otherGas: backendStructure.Params.Contamination.GasDetails[i].OtherGas,

            //Modified by PP(2023-02-17) : Bugs. To check the actual concentration unit - START
            // concentrationValue: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.GasDetails[i].ConcentrationValue),this.userInfoService.userData.currentLocale),
            // altConcUnit: backendStructure.Params.Contamination.GasDetails[i].AltConcUnit,
            // altConcValue: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.GasDetails[i].AltConcValue),this.userInfoService.userData.currentLocale),
            concentrationValue: this.sharedService.formatValue(parseFloat(ActualConcValue), this.userInfoService.userData.currentLocale),
            altConcUnit: ActualAltConcUnit,
            altConcValue: this.sharedService.formatValue(parseFloat(ActualAltConcValue), this.userInfoService.userData.currentLocale),
            //Modified by PP(2023-02-17) : Bugs. To check the actual concentration unit - END
            moreInformation: {},
            otherGasDetails: {
              otherContaminantID: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.OtherContaminationID,
              otherContaminantName: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.OtherContaminationName,
              chemicalFormula: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.ChemicalFormula,
              density: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.Density,
              molecularWeight: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.MolecularWeight,
              boilingPoint: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.BoilingPoint,
              refractiveIndex: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.RefractiveIndex,
              vapourPressureValue: backendStructure.Params.Contamination.GasDetails[i].OtherGasDetails.VapourPressureValue
            }
          }

          if (gasDetails.otherGas) {
            for (var d = 0; d < this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord.length; d++) {
              if (gasDetails.otherGasDetails.otherContaminantID == this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord[d].ID) {
                gasDetails.otherGasDetails.chemicalFormula = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord[d].formula;
                gasDetails.otherGasDetails.density = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord[d].dl;
                gasDetails.otherGasDetails.molecularWeight = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord[d].mw;
                gasDetails.otherGasDetails.boilingPoint = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord[d].tbp;
                gasDetails.otherGasDetails.refractiveIndex = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord[d].ri;
                gasDetails.otherGasDetails.vapourPressureValue = this.sharedService.ApplicationContaminationFromServer.CLDSaveOthersRecord[d].vp;
              }
            }
          }

          if (backendStructure.Params.CalcType === 'ASTM') {
            let moreInfoForGas = {
              chemicalFormula: backendStructure.Params.Contamination.GasDetails[i].MoreInformation.ChemicalFormula,
              vapourPressureValue: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.GasDetails[i].MoreInformation.VapourPressureValue).toFixed(2), this.userInfoService.userData.currentLocale),
              molecularWeight: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.GasDetails[i].MoreInformation.MolecularWeight).toFixed(2), this.userInfoService.userData.currentLocale),
              //boilingPoint: backendStructure.Params.Contamination.GasDetails[i].MoreInformation.BoilingPoint,
              boilingPoint: this.sharedService.formatValue(parseFloat(backendStructure.Params.Contamination.GasDetails[i].MoreInformation.BoilingPoint).toFixed(2), this.userInfoService.userData.currentLocale),
              casNo: backendStructure.Params.Contamination.GasDetails[i].MoreInformation.CasNo
            }
            gasDetails.moreInformation = moreInfoForGas;
          }

          contamination.gasDetails.push(gasDetails);
        }
        projectdetails.contamination = contamination;
        //this.projectdetails.contamination = contamination;

        //Solutions To Compare
        var tmpSolutions = [];
        for (var i = 0; i < backendStructure.Params.Solution2Compare.length; i++) {
          let solutions2Compare = {
            solutionID: backendStructure.Params.Solution2Compare[i].SolutionID,
            solutionName: backendStructure.Params.Solution2Compare[i].SolutionName,
            solutionDetails: []
          }

          for (var j = 0; j < backendStructure.Params.Solution2Compare[i].SolutionDetails.length; j++) {
            let soldet = {
              combinationID: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CombinationID,
              combinationGas: [],
              molecularGroup: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularGroup,
              molecularGroupID: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularGroupID,
              molecularType: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularType,
              molecularTypeID: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularTypeID,
              molecularID: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularID,
              molecularTypeMolecularID: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularTypeMolecularID,
              molecularTypePic: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularTypePic,
              molecularPic: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].MolecularPic,
              filterName: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].FilterName,
              filterDBName: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].FilterDBName,
              inputSize: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].InputSize,
              // customMediaSize: {
              //   height: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.Height,
              //   length: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.Length,
              //   depth: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.Depth
              // },
              customMediaSize: {
                height: this.sharedService.formatValue(parseFloat(backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.Height), this.userInfoService.userData.currentLocale),
                length: this.sharedService.formatValue(parseFloat(backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.Length), this.userInfoService.userData.currentLocale),
                depth: this.sharedService.formatValue(parseFloat(backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.Depth), this.userInfoService.userData.currentLocale),
                shapeType: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.ShapeType, //1: rectangle, 2: cylinder - Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
                diameter: this.sharedService.formatValue(parseFloat(backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CustomMediaSize.Diameter), this.userInfoService.userData.currentLocale) //Modified by Pinky(2026-05-12) : To cater for cylinder filter #126174
              },
              noOfFilter: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].NoOfFilter,
              totalStage: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].TotalStage,
              displayTypeForMoreInfo: "More Information",
              astmWeight: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].ASTMWeight,
              astmvolume: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].ASTMVolume
            }

            for (var k = 0; k < backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CombinationGas.length; k++) {
              let tmpCombineGas = {
                index: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CombinationGas[k].Index,
                chemicalID: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CombinationGas[k].ChemicalID,
                contaminationType: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CombinationGas[k].ContaminationType,
                concentrationValue: backendStructure.Params.Solution2Compare[i].SolutionDetails[j].CombinationGas[k].ConcentrationValue,
              }
              soldet.combinationGas.push(tmpCombineGas);
            }
            solutions2Compare.solutionDetails.push(soldet);
          }
          tmpSolutions.push(solutions2Compare);
        }
        projectdetails.solutions = tmpSolutions;

        if (tmpSolutions.length === 0) {
          let solutions2Compare = this.getSolutionsForComparisonEmptyValueStructure();
          tmpSolutions.push(solutions2Compare);
          projectdetails.solutions = tmpSolutions;
        }
        //this.projectdetails.solutions = tmpSolutions;

        //Results
        //Refer to this.projectService.getSolResultsStructure();

      } catch (e) {
        console.log(e);
        throwError(e.message);
        return undefined;
      }
    }
    this.projectdetails = projectdetails;
    return projectdetails;
  }

  getSolResultsStructure(source_MCCLDResults) {
    let results = {
      ready: false,
      solutionsResults: [],
      comparisonReport: {},
      extractCalcInExcel: {}
      //data:[]      
    }

    let solResults = [];
    for (var i = 0; i < source_MCCLDResults.SolutionResults.length; i++) {
      let mccldSolutionsResults = {
        solutionID: source_MCCLDResults.SolutionResults[i].SolutionID,
        solutionName: '',
        resultReady: source_MCCLDResults.SolutionResults[i].ResultReady,
        results: [],
        report: [],
        astmResults: []
      }

      //Find Solution Name
      var tmpName = '';
      for (var h = 0; h < this.projectdetails.solutions.length; h++) {
        if (this.projectdetails.solutions[h].solutionID == source_MCCLDResults.SolutionResults[i].SolutionID) {
          tmpName = this.projectdetails.solutions[h].solutionName;
          break;
        }
      }
      mccldSolutionsResults.solutionName = tmpName;

      var ResultsForEachSol = []
      for (var j = 0; j < source_MCCLDResults.SolutionResults[i].Results.length; j++) {
        let tmpResults = {
          combinationID: source_MCCLDResults.SolutionResults[i].Results[j].CombinationID,
          combinationGas: [],
          msg: source_MCCLDResults.SolutionResults[i].Results[j].Msg,
          molecularGroup: source_MCCLDResults.SolutionResults[i].Results[j].MolecularGroup,
          molecularGroupID: source_MCCLDResults.SolutionResults[i].Results[j].MolecularGroupID,
          molecularType: source_MCCLDResults.SolutionResults[i].Results[j].MolecularType,
          molecularTypeID: source_MCCLDResults.SolutionResults[i].Results[j].MolecularTypeID,
          molecularID: source_MCCLDResults.SolutionResults[i].Results[j].MolecularID,
          filterName: source_MCCLDResults.SolutionResults[i].Results[j].FilterName,
          filterDBName: source_MCCLDResults.SolutionResults[i].Results[j].FilterDBName,

          effMediaWeight: source_MCCLDResults.SolutionResults[i].Results[j].EffMediaWeight,
          totalWeight: source_MCCLDResults.SolutionResults[i].Results[j].TotalWeight,
          frontVelocity: source_MCCLDResults.SolutionResults[i].Results[j].FrontVelocity,
          pressureDrop: source_MCCLDResults.SolutionResults[i].Results[j].PressureDrop,
          contactTime: source_MCCLDResults.SolutionResults[i].Results[j].ContactTime,
          AtmPressure: source_MCCLDResults.SolutionResults[i].Results[j].AtmPressure,
          Calc_we: source_MCCLDResults.SolutionResults[i].Results[j].Calc_We,
          Calc_Wo: source_MCCLDResults.SolutionResults[i].Results[j].Calc_Wo,
          Calc_B: source_MCCLDResults.SolutionResults[i].Results[j].Calc_B,
          Calc_Kv: source_MCCLDResults.SolutionResults[i].Results[j].Calc_Kv,
          vFv: source_MCCLDResults.SolutionResults[i].Results[j].vFv,
          vFa: source_MCCLDResults.SolutionResults[i].Results[j].vFa,
          vFFa: source_MCCLDResults.SolutionResults[i].Results[j].vFFa,
          vWcf: source_MCCLDResults.SolutionResults[i].Results[j].vWcf,
          Efficiency: [],
          LifeTimeHours: [],
          EfficiencyForGraph: [], //Modified by PP(2021-01-20) : To touch Y Axis
          LifeTimeHoursForGraph: [], //Modified by PP(2021-01-20) : To touch Y Axis
          ExcelFileName: source_MCCLDResults.SolutionResults[i].Results[j].ExcelFileName,
          FilterTypeFilterID: source_MCCLDResults.SolutionResults[i].Results[j].FilterTypeFilterID,
          EffHoursChart: {
            Found: source_MCCLDResults.SolutionResults[i].Results[j].EffHoursChart.Found,
            Message: source_MCCLDResults.SolutionResults[i].Results[j].EffHoursChart.Message,
            Path: source_MCCLDResults.SolutionResults[i].Results[j].EffHoursChart.Path
          },
          moreInformation: {
            pressureDrop: this.sharedService.formatValue(parseFloat(source_MCCLDResults.SolutionResults[i].Results[j].PressureDrop), this.userInfoService.userData.currentLocale),
            totalWeight: this.sharedService.formatValue(parseFloat(source_MCCLDResults.SolutionResults[i].Results[j].TotalWeight).toFixed(2), this.userInfoService.userData.currentLocale)
          }
        }

        // Get CombinationGas array
        for (var k = 0; k < source_MCCLDResults.SolutionResults[i].Results[j].CombinationGas.length; k++) {
          let tmpCombinationGas = {
            Index: source_MCCLDResults.SolutionResults[i].Results[j].CombinationGas[k].Index, //Modified by PP(2023-06-07) : Allow same gas diff conc value
            ChemicalID: source_MCCLDResults.SolutionResults[i].Results[j].CombinationGas[k].ChemicalID,
            ContaminationType: source_MCCLDResults.SolutionResults[i].Results[j].CombinationGas[k].ContaminationType,
            ConcentrationValue: this.sharedService.formatValue(parseFloat(source_MCCLDResults.SolutionResults[i].Results[j].CombinationGas[k].ConcentrationValue), this.userInfoService.userData.currentLocale) //Modified by PP(2023-06-07) : Allow same gas diff conc value
          }
          tmpResults.combinationGas.push(tmpCombinationGas);
        }

        // Get Efficiency array
        if (source_MCCLDResults.SolutionResults[i].Results[j].Efficiency != null || source_MCCLDResults.SolutionResults[i].Results[j].Efficiency != undefined) {
          for (var l = 0; l < source_MCCLDResults.SolutionResults[i].Results[j].Efficiency.length; l++) {
            //tmpResults.Efficiency.push(this.sharedService.formatValue(parseFloat(source_MCCLDResults.SolutionResults[i].Results[j].Efficiency[l]),this.userInfoService.userData.currentLocale));
            tmpResults.Efficiency.push(source_MCCLDResults.SolutionResults[i].Results[j].Efficiency[l]);
          }
        }

        // Get LifeTimeHours array
        if (source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHours != null || source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHours != undefined) {
          for (var l = 0; l < source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHours.length; l++) {
            //tmpResults.LifeTimeHours.push(this.sharedService.formatValue(parseFloat(source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHours[l]),this.userInfoService.userData.currentLocale));
            tmpResults.LifeTimeHours.push(source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHours[l]);
          }
        }

        //Modified by PP(2021-01-20) : To touch Y Axis - START
        // Get EfficiencyForGraph array
        if (source_MCCLDResults.SolutionResults[i].Results[j].EfficiencyForGraph != null || source_MCCLDResults.SolutionResults[i].Results[j].EfficiencyForGraph != undefined) {
          for (var l = 0; l < source_MCCLDResults.SolutionResults[i].Results[j].EfficiencyForGraph.length; l++) {
            tmpResults.EfficiencyForGraph.push(source_MCCLDResults.SolutionResults[i].Results[j].EfficiencyForGraph[l]);
          }
        }

        // Get LifeTimeHoursForGraph array
        if (source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHoursForGraph != null || source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHoursForGraph != undefined) {
          for (var l = 0; l < source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHoursForGraph.length; l++) {
            tmpResults.LifeTimeHoursForGraph.push(source_MCCLDResults.SolutionResults[i].Results[j].LifeTimeHoursForGraph[l]);
          }
        }
        //Modified by PP(2021-01-20) : To touch Y Axis - END

        ResultsForEachSol.push(tmpResults);
      }
      mccldSolutionsResults.results = ResultsForEachSol;

      solResults.push(mccldSolutionsResults);
    }

    results.ready = source_MCCLDResults.ResultReady;
    results.solutionsResults = solResults;

    //Extract Calculation into Excel
    let tmpExtractCalc = {
      found: source_MCCLDResults.ExtractCalcInExcel.Found,
      path: source_MCCLDResults.ExtractCalcInExcel.Path,
      message: source_MCCLDResults.ExtractCalcInExcel.Message
    }
    results.extractCalcInExcel = tmpExtractCalc;

    //Comparison Report
    let tmpComparisonRpt = {
      found: source_MCCLDResults.ComparisonReport.Found,
      path: source_MCCLDResults.ComparisonReport.Path,
      message: source_MCCLDResults.ComparisonReport.Message
    }
    results.comparisonReport = tmpComparisonRpt;

    return results;
  }

  getAstmSolResultStructure(sourceResult: any) {
    let arr_astmResults = [];
    for (let i = 0; i < sourceResult.SolutionResults.length; i++) {
      let source = sourceResult.SolutionResults[i];
      let astmresult = {
        combinationID: source.ASTMResults.CombinationID,
        combinationGas: {
          chemicalID: source.ASTMResults.CombinationGas[0].ChemicalID,
          contaminationType: source.ASTMResults.CombinationGas[0].ContaminationType
        },
        atmPressure: this.sharedService.formatValue(parseFloat(source.ASTMResults.AtmPressure), this.userInfoService.userData.currentLocale),
        vapourPressure: this.sharedService.formatValue(parseFloat(source.ASTMResults.VapourPressure), this.userInfoService.userData.currentLocale),
        vapourPressureMMHg: this.sharedService.formatValue(parseFloat(source.ASTMResults.VapourPressureMmHg), this.userInfoService.userData.currentLocale),
        contaminantPerYear: this.sharedService.formatValue(parseFloat(source.ASTMResults.ContaminantPerYear).toFixed(2), this.userInfoService.userData.currentLocale),
        mediaConsumption12Month: this.sharedService.formatValue(parseFloat(source.ASTMResults.MediaConsumption12Month).toFixed(2), this.userInfoService.userData.currentLocale),
        mediaConsumption1Month: this.sharedService.formatValue(parseFloat(source.ASTMResults.MediaConsumption1Month).toFixed(2), this.userInfoService.userData.currentLocale),
        mediaConsumption3Month: this.sharedService.formatValue(parseFloat(source.ASTMResults.MediaConsumption3Month).toFixed(2), this.userInfoService.userData.currentLocale),
        mediaConsumption6Month: this.sharedService.formatValue(parseFloat(source.ASTMResults.MediaConsumption6Month).toFixed(2), this.userInfoService.userData.currentLocale),
        mediaConsumption24Month: this.sharedService.formatValue(parseFloat(source.ASTMResults.MediaConsumption24Month).toFixed(2), this.userInfoService.userData.currentLocale),
        mediaID: source.ASTMResults.MediaID,
        mediaPicture: this.sharedService.filterPhotoPath + source.ASTMResults.MediaPhoto
      };
      let result = {
        solutionID: source.SolutionID,
        astmResults: astmresult
      };
      arr_astmResults.push(result);
    }
    return arr_astmResults;
  }

  PerformAstmCalculation(): Observable<any> {
    let body = {
      'ApplicationID': this.sharedService.ApplicationID,
      'UserID': this.userInfoService.userData.UserId,
      'UserName': this.userInfoService.userData.UserName,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'TempStringStorageID': this.sharedService.TempStringStorageID,
      'TotalSeq': this.sharedService.TempStringStorageTotalSeq,
      'RegionID': this.userInfoService.userData.RegionId
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDAstmCalculation', body).pipe(catchError(this.sharedService.handleError));
  }

  PerformMCCLDCalculation(isSolutionPage, pWhichCombination, pForReport, pForExcel): Observable<any> {
    let body = {
      'ApplicationID': this.sharedService.ApplicationID,
      'LanguageID': this.userInfoService.userData.LanguageId.toString(),
      'UserID': this.userInfoService.userData.UserId,
      'UserName': this.userInfoService.userData.UserName,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'TempStringStorageID': this.sharedService.TempStringStorageID,
      'TotalSeq': this.sharedService.TempStringStorageTotalSeq,
      'RegionID': this.userInfoService.userData.RegionId,
      'GenerateChart': false,
      'IsSolutionPage': isSolutionPage,
      'WhichCombination': pWhichCombination,
      'ForReport': pForReport,
      'ForExcel': pForExcel
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDCalculation', body).pipe(catchError(this.sharedService.handleError));
  }

  generateAstmReport(): Observable<any> {
    let body = {
      'Username': this.userInfoService.userData.UserName,
      'RegionID': this.userInfoService.userData.RegionId,
      'ApplicationID': this.sharedService.ApplicationID,
      'Code': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'UserID': this.userInfoService.userData.UserId,
      'LanguageID': 1,
      'ForReport': true,
      'ForExcel': false,
      'TempStringStorageID': this.sharedService.TempStringStorageID,
      'TotalSeq': this.sharedService.TempStringStorageTotalSeq
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'GenerateASTMReport', body).pipe(catchError(this.sharedService.handleError));
  }

  generateResultRequired(fullResult) {
    let require = true;
    let ori = this.projectDetails_successResult;
    if (ori !== '') {
      let json_current = this.convertProjectEntriesToJson(this.projectdetails)
      if (json_current === ori) {
        require = false;
      }
    }

    if (require === false) {
      if (fullResult) { // From Results Page to include Graph Generation
        //astm results array don't have chart. solutions array also wrong
        // let results = this.projectdetails.results;
        // let solutions = this.projectdetails.solutions.solutionDetails;
        // if (results != undefined && solutions != undefined) {
        //   if (results.data.length == solutions.length) {
        //     require=false;
        //   }
        //   if (results.chart.length > 0 ) {
        //     require=false;
        //   }
        // }
        let results = this.projectdetails.results.solutionsResults;
        let solutions = this.projectdetails.solutions;
        if (results != undefined && solutions != undefined) {
          if (results.length == solutions.length) {
            require = false;
          }
        }
      } else { // From Summary Page and no need to generate graphs
        let results = this.projectdetails.results;
        let solutions = this.projectdetails.solutions.solutionDetails;
        if (results != undefined && solutions != undefined) {
          if (results.length == solutions.length) {
            require = false;
          }
        }
      }
    }

    return require;
  }

  convertProjectEntriesToJson(data) {
    let projectEntries = {
      //projectId:data.projectId,
      //category:data.category,
      customerInfo: data.customerInfo,
      siteInfo: data.siteInfo,
      contamination: data.contamination,
      solutions: data.solutions,
      results: []
    }
    return JSON.stringify(projectEntries);
  }

  ValidateDataEntries() {
    var Data: any = {};
    this.errPage = '';

    //Validate Contamination
    if (this.projectdetails.contamination !== undefined) {
      let validContamination = this.validateContamination(this.projectdetails.contamination);
      if (validContamination === false) {
        this.errPage = 'Contamination';
        return false;
      }
    }

    //Validate Solutions
    if (this.projectdetails.solutions !== undefined) {
      let validSolutions = this.validateSolutions(this.projectdetails.solutions);
      if (validSolutions === false) {
        this.errPage = 'Solutions';
        return false;
      }
    }

    return true;
  }

  generateReport(): Observable<any> {
    let body = {
      'UserID': this.userInfoService.userData.UserId,
      'UserName': this.userInfoService.userData.UserName,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'ApplicationID': this.sharedService.ApplicationID,
      'RegionID': this.userInfoService.userData.RegionId,
      'LanguageID': this.userInfoService.userData.LanguageId.toString(),
      'TempStringStorageID': this.sharedService.TempStringStorageID,
      'TotalSeq': this.sharedService.TempStringStorageTotalSeq,
      'SkipGenerateChart': false
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'GenerateMCCLDReportsInZipFolder', body).pipe(catchError(this.sharedService.handleError));
    
  }

  SaveProjectToDb() {
    let body = {
      'UserID': this.userInfoService.userData.UserId,
      'UserName': this.userInfoService.userData.UserName,
      'Code': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'ApplicationID': this.sharedService.ApplicationID,
      'RegionID': this.userInfoService.userData.RegionId.toString(),
      TempStringStorageID: this.sharedService.TempStringStorageID,
      TotalSeq: this.sharedService.TempStringStorageTotalSeq
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDSaveCalculationToDb', body, { responseType: 'text' }).pipe(catchError(this.sharedService.handleError));
  }

  getMoreInfoForSolutionDetails() {
    for (let i = 0; i < this.projectdetails.solutions.length; i++) {
      for (let j = 0; j < this.projectdetails.solutions[i].solutionDetails.length; j++) {
        //if (this.projectdetails.solutions[i].solutionDetails[j].moreInformation == undefined) {
        if (this.projectdetails.results != undefined) {
          if (this.projectdetails.results.solutionsResults.length != undefined) { //was results. i added solutionResults on 7th Apr 2023
            for (let y = 0; y < this.projectdetails.results.solutionsResults.length; y++) {
              if (this.projectdetails.solutions[i].solutionID == this.projectdetails.results.solutionsResults[y].solutionID) {
                if (this.projectdetails.results.solutionsResults[y].results.length > 0) {
                  for (let z = 0; z < this.projectdetails.results.solutionsResults[y].results.length; z++) {
                    if (this.projectdetails.solutions[i].solutionDetails[j].combinationID == this.projectdetails.results.solutionsResults[y].results[z].combinationID) {
                      let newMoreInfoDetails = this.getMoreInfoForSolutionEmptyvalueStructure();
                      newMoreInfoDetails.effectiveMediaWeight = this.sharedService.formatValue(parseFloat(this.projectdetails.results.solutionsResults[y].results[z].effMediaWeight.toFixed(2)), true);
                      newMoreInfoDetails.frontVelocity = this.sharedService.formatValue(parseFloat(this.projectdetails.results.solutionsResults[y].results[z].frontVelocity.toFixed(2)), true);
                      newMoreInfoDetails.totalWeight = this.sharedService.formatValue(parseFloat(this.projectdetails.results.solutionsResults[y].results[z].totalWeight.toFixed(2)), true);
                      newMoreInfoDetails.contactTime = this.sharedService.formatValue(parseFloat(this.projectdetails.results.solutionsResults[y].results[z].contactTime.toFixed(2)), true);
                      this.projectdetails.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;
                    }
                  }
                } else { //No Results means Incomplete
                  let newMoreInfoDetails = this.getMoreInfoForSolutionEmptyvalueStructure();
                  newMoreInfoDetails.effectiveMediaWeight = 0;
                  newMoreInfoDetails.frontVelocity = 0;
                  newMoreInfoDetails.totalWeight = 0;
                  newMoreInfoDetails.contactTime = 0;
                  this.projectdetails.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;
                }
              }
            }
          } else { //No Results means Incomplete
            let newMoreInfoDetails = this.getMoreInfoForSolutionEmptyvalueStructure();
            newMoreInfoDetails.effectiveMediaWeight = 0;
            newMoreInfoDetails.frontVelocity = 0;
            newMoreInfoDetails.totalWeight = 0;
            newMoreInfoDetails.contactTime = 0;
            this.projectdetails.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;
          }
        } else { //No Results means Incomplete
          let newMoreInfoDetails = this.getMoreInfoForSolutionEmptyvalueStructure();
          newMoreInfoDetails.effectiveMediaWeight = 0;
          newMoreInfoDetails.frontVelocity = 0;
          newMoreInfoDetails.totalWeight = 0;
          newMoreInfoDetails.contactTime = 0;
          this.projectdetails.solutions[i].solutionDetails[j].moreInformation = newMoreInfoDetails;
        }
        //}
      }
    }
  }

  saveNewOtherGas(pOtherChemIDToSave): Observable<any> {
    let body = {
      'ApplicationID': this.sharedService.ApplicationID,
      'UserID': this.userInfoService.userData.UserId,
      'UserName': this.userInfoService.userData.UserName,
      'LoginCode': this.loginService.cookieSvc.get("CFSSLoginCode"),
      'TempStringStorageID': this.sharedService.TempStringStorageID,
      'TotalSeq': this.sharedService.TempStringStorageTotalSeq,
      'RegionID': this.userInfoService.userData.RegionId,
      'UnitID': this.userInfoService.userData.UserUnitId,
      'ChemID': pOtherChemIDToSave,
    }
    return this.httpService.post(SharedService.applicationServiceUrl + SharedService.sMccldService + 'MCCLDSaveOtherChemical', body).pipe(catchError(this.sharedService.handleError));
  }
}

